// src/pages/TermsAndConditions.js

import React from 'react';

const TermsAndConditions = () => {
  return (
    <div>
      <div className='main'>
        <div className="column1"></div>
        <div className="column2">
          <br />
          <br />
          <div style={{ textAlign: 'center' }}>
            <h1>Terms and Conditions</h1>
          </div>
          <br />
          <p><strong>Welcome to Sabrenetics</strong></p>

          <p>These terms and conditions outline the rules and regulations for the use of Sabrenetics' Website, located at www.sabrenetics.com.</p>

          <p><strong>1. Introduction</strong></p>
          <p>By accessing this website, we assume you accept these terms and conditions. Do not continue to use www.sabrenetics.com if you do not agree to all of the terms and conditions stated on this page.</p>

          <p><strong>2. Intellectual Property Rights</strong></p>
          <p>Other than the content you own, under these Terms, Sabrenetics and/or its licensors own all the intellectual property rights and materials contained in this website.</p>

          <p><strong>3. Restrictions</strong></p>
          <p>You are specifically restricted from all of the following:
            <ul>
              <li>Publishing any website material in any other media without permission</li>
              <li>Selling, sublicensing and/or otherwise commercializing any website material</li>
              <li>Using this website in any way that is or may be damaging to this website</li>
              <li>Using this website in any way that impacts user access to this website</li>
              <li>Using this website contrary to applicable laws and regulations</li>
            </ul>
          </p>

          <p><strong>4. Your Privacy</strong></p>
          <p>Please read our Privacy Policy.</p>

          <p><strong>5. Your Content</strong></p>
          <p>In these website standard terms and conditions, "Your Content" shall mean any audio, video text, images or other material you choose to display on this website. By displaying Your Content, you grant Sabrenetics a non-exclusive, worldwide irrevocable, sub-licensable license to use, reproduce, adapt, publish, translate and distribute it in any and all media.</p>

          <p><strong>6. Shopping Experience</strong></p>
          <p>When purchasing educational materials and event tickets, you agree to provide accurate and complete information. All prices are subject to change without notice.</p>

          <p><strong>7. Account Management</strong></p>
          <p>You are responsible for maintaining the confidentiality of your account and password and for restricting access to your computer. You agree to accept responsibility for all activities that occur under your account or password.</p>

          <p><strong>8. Limitation of Liability</strong></p>
          <p>In no event shall Sabrenetics, nor any of its officers, directors and employees, be held liable for anything arising out of or in any way connected with your use of this website.</p>

          <p><strong>9. Indemnification</strong></p>
          <p>You hereby indemnify to the fullest extent Sabrenetics from and against any and all liabilities, costs, demands, causes of action, damages and expenses arising in any way related to your breach of any of the provisions of these Terms.</p>

          <p><strong>10. Variation of Terms</strong></p>
          <p>Sabrenetics is permitted to revise these Terms at any time as it sees fit, and by using this website you are expected to review these Terms on a regular basis.</p>

          <p><strong>11. Entire Agreement</strong></p>
          <p>These Terms constitute the entire agreement between Sabrenetics and you in relation to your use of this website, and supersede all prior agreements and understandings.</p>

          <p><strong>SECTION 20 - CONTACT INFORMATION</strong></p>
          <p>Questions about the Terms of Service should be sent to us at:</p>
          <p>
            Email: support@sabrenetics.com<br />
            Trading name: Sabrenetics<br />
            Address: B1/13-21 Mandible St Alexandria NSW 2015, Australia<br />
            Phone number: 0433 546 300<br />
            ACN: 655 184 946<br />
            ABN: 89 655 184 946<br />
            Business Registration number: 89 655 184 946<br />
          </p>
        </div>
        <div className="column3"></div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
